import { render, staticRenderFns } from "./assignTraining.vue?vue&type=template&id=6c9a2bc2"
import script from "./assignTraining.vue?vue&type=script&lang=js"
export * from "./assignTraining.vue?vue&type=script&lang=js"
import style0 from "./assignTraining.vue?vue&type=style&index=0&id=6c9a2bc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports